import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    delivery_container: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 12px',
        borderRadius: 8,
        backgroundColor: '#f5f7fa',
        color: '#2c3e50',
        width: 'fit-content',
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.main,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        lineHeight: 1.2,
    },
    label: {
        fontSize: 12,
        color: '#7f8c8d',
    },
    value: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 14,
    },
    time_icon: {
        fontSize: 16,
        opacity: 0.7,
    },
    unit: {
        marginLeft: 2,
        fontSize: 13,
        opacity: 0.8,
    },
    undefined: {
        backgroundColor: '#f2f2f2',
        color: '#95a5a6',
    },
    undefined_value: {
        fontSize: 13,
        fontStyle: 'italic',
    },
}));

export {useStyles}